module.exports = __webpack_public_path__ + "static/media/nynfc9.04aa48b5.jpg";